import React from "react";
import styles from "./Hero.module.css";
import { BiDownArrow } from "react-icons/bi";
import Typewriter from "typewriter-effect";
const Hero = () => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainText}>
        <h1 className={styles.heroMainHeader}>
          <p> KEEP IT</p>
          <span>
            <Typewriter
              options={{
                strings: [" SIMPLE", " SMALL", " EASY"],
                autoStart: true,
                loop: true,
                pauseFor: 2000,
              }}
            />
          </span>
        </h1>
        <h1 className={styles.heroMainHeader1}>WITH</h1>
        <h1 className={styles.heroMainHeader2}>
          <p>THE</p> <span> TRANSCRIPTER</span>
        </h1>
        <p className={styles.heroSecondaryHeader}>
          Ctrl + V is all it takes to save your Time. It's really that simple.
        </p>
      </div>
    </div>
  );
};

export default Hero;
